import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-student-accommodations-card',
  templateUrl: './student-accommodations-card.component.html',
  styleUrls: ['./student-accommodations-card.component.scss']
})
export class StudentAccommodationsCardComponent implements OnDestroy {

  @Input() inputProfileData: any;
  @Output() profileUpdate: EventEmitter<any> = new EventEmitter<any>();
  formsTouched = false;

  changeValue(option) {
    this.formsTouched = true;
    option.checkedValue = !option.checkedValue;
  }

  getSpecialConsidrationData() {
    return this.inputProfileData;
  }

  ngOnDestroy() {
    this.formsTouched = false;
  }
}
